module.exports = __webpack_public_path__ + "media/svg/pt-8de16659.svg";